import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const MostPopularCardWrapper = styled.div`
  height: 100px;
  display: flex;
  margin-bottom: 24px;
  &:last-of-type {
    margin-bottom: 0;
  }
  &:hover #most-popular-title {
    text-decoration: underline;
  }
  @media (${mediaQuery.tablet}) {
    margin-bottom: 16px;
  }
  @media (${mediaQuery.mobile}) {
    height: 64px;
  }
`;

export const MostPopularPostImageWrapper = styled.a`
  padding-right: 12px;
  img {
    width: 172px;
    height: 100px;
    border-radius: 3px;
    @media (${mediaQuery.mobile}) {
      width: 112px;
      height: 64px;
    }
  }
`;

export const MostPopularPostTitleWrapper = styled.h3`
  height: 78px;
  overflow: hidden;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  a {
    color: #333f48;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  a:hover {
    text-decoration-line: underline;
    color: #333f48;
  }
  @media (${mediaQuery.tablet}) {
    font-size: 18px;
  }
  @media (${mediaQuery.mobile}) {
    font-size: 16px;
    line-height: 20px;
    height: 40px;
  }
`;

export const MostPopularPostCategoryWrapper = styled.div`
  a {
    color: #697684;
    &:hover {
      color: #697684;
    }
  }
  font-size: 14px;
  font-weight: 300;
  line-height: 14px;
  margin-bottom: 4px;
  @media (${mediaQuery.tablet}) {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 6px;
  }
  @media (${mediaQuery.mobile}) {
    height: 14px;
    line-height: 12px;
    font-size: 12px;
    margin-bottom: 6px;
  }
`;
